module.exports = __webpack_public_path__ + "static/media/ico_native_endpoint_o.5dc32f75.svg";